import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import AddOnProduct from "./AddOnProduct";
import AddAddOnProductButton from "./AddAddOnProductButton";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col,
    Form,
    FormFeedback,
    Row,
    Input,
    Label,
    Button,
    AccordionHeader,
    UncontrolledAccordion,
    AccordionItem, AccordionBody, Accordion
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getAddOnProducts} from "../../api/api";
import {toast} from "react-toastify";
import RecordsNotFound from "../../components/RecordsNotFound";


function AddOnProductPage() {
    const {refreshToken, user} = useContext(AuthContext)
    const [page, setPage] = useState(1);
    const [addOnProductId, setAddOnProductId] = useState("");
    const [addOnProductName, setAddOnProductName] = useState("");
    const [addOnProductPrice, setAddOnProductPrice] = useState("");
    const [addOnProductDescription, setAddOnProductDescription] = useState("");
    const [addOnProductStock, setAddOnProductStock] = useState("");
    // const [addOnProductTaxType, setAddOnProductTaxType] = useState("");
    const [addOnProductUPC, setAddOnProductUPC] = useState("");
    const [addOnProductStatus, setAddOnProductStatus] = useState("");
    const [addOnProductCreatedDate, setAddOnProductCreatedDate] = useState("");
    const [addOnProductUpdatedDate, setAddOnProductUpdatedDate] = useState("");
    const [addOnProductIsDigital, setAddOnProductIsDigital] = useState("");
    const [queryKey, setQueryKey] = useState(['add-on-products', page])
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);
    const [isAdvancedSearchDisabled, setIsAdvancedSearchDisabled] = useState(false);

    const toggleAdvancedSearch = () =>
        setOpenAdvancedSearch((prevState) => !prevState);

    useEffect(() => {
        setQueryKey(['add-on-products', page])
    }, [page]);

    useEffect(() => {
        if(addOnProductId === '' && addOnProductName === '' && addOnProductPrice === '' && addOnProductDescription === '' &&
            addOnProductCreatedDate === '' && addOnProductIsDigital === '' && addOnProductStock === '' &&
            addOnProductStatus === '' && addOnProductUPC === '' && addOnProductUpdatedDate === ''){
            clearSearchProduct()
        }
    }, [addOnProductId, addOnProductName, addOnProductPrice, addOnProductDescription, addOnProductCreatedDate,
        addOnProductIsDigital, addOnProductStock, addOnProductStatus, addOnProductUPC, addOnProductUpdatedDate]);

    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getAddOnProducts(page, addOnProductId, addOnProductName, addOnProductPrice,
            addOnProductDescription, addOnProductStock, addOnProductStatus, addOnProductUPC, addOnProductCreatedDate,
            addOnProductIsDigital, addOnProductUpdatedDate),
        keepPreviousData : true,
        retry: false,
        refetchOnWindowFocus: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
        })

    const shouldShowInitialLoader = status === 'loading' && !data;
    const shouldShowAddOnProductTable = status === 'success' || Boolean(data) || error?.response?.status === 401;

    const searchProduct = (e) =>{
        e?.preventDefault()
        setPage(1)
        setQueryKey( ['add-on-products', page, addOnProductId, addOnProductName, addOnProductPrice,
            addOnProductDescription, addOnProductStock, addOnProductStatus, addOnProductUPC, addOnProductCreatedDate,
            addOnProductIsDigital, addOnProductUpdatedDate])
    }

    const clearSearchProduct = (e) =>{
        e?.preventDefault()
        setAddOnProductId('')
        setAddOnProductName('')
        setAddOnProductDescription('')
        setAddOnProductPrice('')
        setAddOnProductStock('')
        // setAddOnProductTaxType('')
        setAddOnProductStatus('')
        setAddOnProductUPC('')
        setAddOnProductCreatedDate('')
        setAddOnProductIsDigital('')
        setAddOnProductUpdatedDate('')
        setQueryKey( ['add-on-products', 1])
        // setPage(1)
    }

    return (
        <>
            <UncontrolledAccordion defaultOpen="" flush={true}>
                <AccordionItem>
                    <AccordionHeader targetId="1">
                        <span><i className="mdi mdi-filter"/></span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                        <div className="card-box">
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form onSubmit={searchProduct}>
                                        <Row className="form-row align-items-center">
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="name"
                                                >
                                                    Add On Product Name
                                                </Label>
                                                <Input
                                                    id="add-on-product-name"
                                                    name="add-on-product-name"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setAddOnProductName(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={addOnProductName}
                                                    invalid={
                                                        error && error.response.data.name
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.name}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="price"
                                                >
                                                    Price
                                                </Label>
                                                <Input
                                                    id="add-on-product-price"
                                                    name="add-on-product-price"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setAddOnProductPrice(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={addOnProductPrice}
                                                    invalid={
                                                        error && error.response.data.price
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.price}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="price"
                                                >
                                                    Description
                                                </Label>
                                                <Input
                                                    id="description"
                                                    name="description"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setAddOnProductDescription(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={addOnProductDescription}
                                                    invalid={
                                                        error && error.response.data.description
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.description}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="add-on-product-status"
                                                >
                                                    Status
                                                </Label>
                                                <Input
                                                    type="select"
                                                    id="add-on-product-status"
                                                    className="form-control mb-2"
                                                    value={addOnProductStatus}
                                                    onChange={(e) =>
                                                        setAddOnProductStatus(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">--</option>
                                                    <option value={"ACTIVE"}>
                                                        Active
                                                    </option>
                                                    <option value={"INACTIVE"}>
                                                        Inactive
                                                    </option>
                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="add-on-product-date-created"
                                                >
                                                    Date Created
                                                </Label>
                                                <Input
                                                    id="add-on-product-date-created"
                                                    name="add-on-product-date-created"
                                                    type="date"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setAddOnProductCreatedDate(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={addOnProductCreatedDate}
                                                    invalid={
                                                        error && error.response.data.created
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.created}
                                                </FormFeedback>
                                            </Col>
                                        </Row>
                                        {!isAdvancedSearchDisabled && (
                                            <>
                                                <Row className="form-row align-items-center">
                                                    <Col>
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="advanced-search"
                                                                defaultChecked={openAdvancedSearch}
                                                                disabled={isAdvancedSearchDisabled}
                                                                onChange={() =>
                                                                    toggleAdvancedSearch()
                                                                }
                                                            />
                                                            <Label
                                                                check
                                                                className="form-check-label mb-2"
                                                                for="advanced-search"
                                                            >
                                                                Advanced Search
                                                            </Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Accordion open={openAdvancedSearch}>
                                                    <AccordionItem>
                                                        <AccordionBody accordionId={true}>
                                                            <Row className="form-row align-items-center">
                                                                {/*<Col>*/}
                                                                {/*    <Label*/}
                                                                {/*        className="visually-hidden"*/}
                                                                {/*        for="add-on-product-tax-type"*/}
                                                                {/*    >*/}
                                                                {/*        Tax Type*/}
                                                                {/*    </Label>*/}
                                                                {/*    <Input*/}
                                                                {/*        type="select"*/}
                                                                {/*        id="inputState"*/}
                                                                {/*        className="form-control mb-2"*/}
                                                                {/*        value={addOnProductTaxType}*/}
                                                                {/*        onChange={(e) =>*/}
                                                                {/*            setAddOnProductTaxType(*/}
                                                                {/*                e.target.value*/}
                                                                {/*            )*/}
                                                                {/*        }*/}
                                                                {/*    >*/}
                                                                {/*        <option value="">--</option>*/}
                                                                {/*        <option value={"TAX-INCLUSIVE"}>*/}
                                                                {/*            Tax Inclusive*/}
                                                                {/*        </option>*/}
                                                                {/*        <option value={"TAX-EXCLUSIVE"}>*/}
                                                                {/*            Tax Exclusive*/}
                                                                {/*        </option>*/}
                                                                {/*    </Input>*/}
                                                                {/*</Col>*/}
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="add-on-product-stock"
                                                                    >
                                                                        Stock
                                                                    </Label>
                                                                    <Input
                                                                        id="add-on-product-stock"
                                                                        name="add-on-product-stock"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setAddOnProductStock(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={addOnProductStock}
                                                                        invalid={
                                                                            error && error.response.data.stock
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.stock}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="upc"
                                                                    >
                                                                        UPC
                                                                    </Label>
                                                                    <Input
                                                                        id="upc"
                                                                        name="upc"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setAddOnProductUPC(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={addOnProductUPC}
                                                                        invalid={
                                                                            error && error.response.data.upc
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.upc}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="add-on-product-type"
                                                                    >
                                                                        Type
                                                                    </Label>
                                                                    <Input
                                                                        type="select"
                                                                        id="inputState"
                                                                        className="form-control mb-2"
                                                                        value={addOnProductIsDigital}
                                                                        onChange={(e) =>
                                                                            setAddOnProductIsDigital(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value="">--</option>
                                                                        <option value={true}>
                                                                            Digital Product
                                                                        </option>
                                                                        <option value={false}>
                                                                            Physical Product
                                                                        </option>
                                                                    </Input>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="add-on-product-date-updated"
                                                                    >
                                                                        Date Updated
                                                                    </Label>
                                                                    <Input
                                                                        id="add-on-product-date-updated"
                                                                        name="add-on-product-date-updated"
                                                                        type="date"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setAddOnProductUpdatedDate(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={addOnProductUpdatedDate}
                                                                        invalid={
                                                                            error && error.response.data.updated
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.updated}
                                                                    </FormFeedback>
                                                                </Col>
                                                            </Row>
                                                        </AccordionBody>
                                                    </AccordionItem>
                                                </Accordion>
                                            </>
                                        )}
                                        <Row className="form-row align-items-center">
                                            {isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button type="submit"
                                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                            disabled={!addOnProductName && !addOnProductPrice &&
                                                            !addOnProductDescription && !addOnProductStatus &&
                                                            !addOnProductCreatedDate}
                                                    >
                                                        Search
                                                    </Button>

                                                    <Button type="button"
                                                            onClick={clearSearchProduct}
                                                            className="btn bx-btn-primary waves-effect waves-light"
                                                            disabled={!addOnProductName && !addOnProductPrice &&
                                                            !addOnProductDescription && !addOnProductStatus &&
                                                            !addOnProductCreatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                            {!isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button type="submit"
                                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                            disabled={!addOnProductName && !addOnProductPrice &&
                                                            !addOnProductDescription && !addOnProductStatus &&
                                                            !addOnProductCreatedDate &&
                                                            !addOnProductStock && !addOnProductUPC &&
                                                            !addOnProductIsDigital && !addOnProductUpdatedDate}
                                                    >
                                                        Search
                                                    </Button>

                                                    <Button type="button"
                                                            onClick={clearSearchProduct}
                                                            className="btn bx-btn-primary waves-effect waves-light"
                                                            disabled={!addOnProductName && !addOnProductPrice &&
                                                            !addOnProductDescription && !addOnProductStatus &&
                                                            !addOnProductCreatedDate && !addOnProductUPC &&
                                                            !addOnProductStock &&
                                                            !addOnProductIsDigital && !addOnProductUpdatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </UncontrolledAccordion>

            <div className="row">
                <div className="col-12">

                    <div className="card-box">
                        <AddAddOnProductButton/>
                        {shouldShowInitialLoader && (
                            <Loader size={'default'}/>
                        )}
                        {shouldShowAddOnProductTable && (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-centered mb-0">
                                        <thead className="font-13 bg-light text-muted">
                                        <tr>
                                            <th className="font-weight-medium">Image</th>
                                            <th className="font-weight-medium">Add On Product Name</th>
                                            <th className="font-weight-medium">Price</th>
                                            <th className="font-weight-medium">Products Supported</th>
                                            <th className="font-weight-medium">Status</th>
                                            <th className="font-weight-medium">Stock</th>
                                            <th className="font-weight-medium">Inventory Tracking</th>
                                            {/*<th className="font-weight-medium">Tax</th>*/}
                                            <th className="font-weight-medium">Created</th>
                                            <th className="font-weight-medium text-center">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data?.count > 0 ? data?.results?.map(addOnProduct => (
                                            <AddOnProduct key={addOnProduct.id} addOnProduct={addOnProduct}/>
                                        )) : <RecordsNotFound/>}
                                        </tbody>
                                    </table>
                                </div>
                                {status === 'success' && (
                                    <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddOnProductPage;
